import React, { useContext, useCallback, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { KioskContext } from '../context/kiosk';
import { useInactivityTimer } from '../hooks/useInactivityTimer';
import InactivityWarning from './InactivityWarning';
import { HotelContext } from '../context/hotel';

/**
 * KioskInactivityManager
 * Componente que gestiona la inactividad en modo Kiosk
 * Se encarga de mostrar advertencias y desloguear al usuario si está inactivo
 */
const KioskInactivityManager = () => {
  const location = useLocation();
  const { data: hotel } = useContext(HotelContext);
  const navigate = useNavigate();
  const { 
    isKioskMode, 
    isKioskLoggedIn,
    setLogoutKiosk,
    inactivityWarningActive,
    setInactivityWarningActive,
    inactivityTimeoutMs
  } = useContext(KioskContext);

  const handleInactivityWarning = useCallback(() => {
    console.log('📢 Mostrando advertencia de inactividad');
    setInactivityWarningActive(true);
  }, [setInactivityWarningActive]);

  const handleLogout = useCallback(() => {
    console.log('🚪 Deslogueando por inactividad');
    setInactivityWarningActive(false);
    navigate(`/${hotel?.code}/checkin/identify`, { replace: true });
  }, [setLogoutKiosk, setInactivityWarningActive]);

  const handleDismissWarning = useCallback(() => {
    console.log('🚪 Usuario confirmó inactividad');
    setInactivityWarningActive(false);
  }, [setInactivityWarningActive]);

  // Pantallas donde no se debe mostrar la advertencia de inactividad
  const whiteListScreens = useMemo(() => {
    let locationPath = location.pathname;
    return locationPath.includes('/checkin/identify') || locationPath.includes('/kiosk/login');
  }, [location.pathname, isKioskMode, isKioskLoggedIn]);

  // Solo activar el timer si estamos en modo Kiosk, el usuario está logueado y NO estamos en las pantallas de la white list
  const isTimerEnabled = isKioskMode && isKioskLoggedIn && !whiteListScreens;

  const { isWarningActive } = useInactivityTimer(
    inactivityTimeoutMs,
    handleInactivityWarning,
    handleLogout,
    isTimerEnabled
  );

  if (!isKioskMode || whiteListScreens) return null;

  return (
    <InactivityWarning
      isActive={inactivityWarningActive || isWarningActive}
      onDismiss={handleDismissWarning}
      onLogout={handleLogout}
      countdownSeconds={30}
    />
  );
};

export default KioskInactivityManager;

